import { __assign } from "tslib";
import React from 'react';
import { I18nextProvider, initI18n } from '@wix/wix-i18n-config';
import { LOCALES } from '../constants';
export function withI18nextProvider(Comp) {
    return function (props) {
        var messages;
        try {
            messages = require("../locales/messages_".concat(props.locale, ".json"));
        }
        catch (error) {
            messages = require('../locales/messages_en.json');
        }
        var i18n = initI18n({
            locale: props.locale || LOCALES.EN,
            messages: messages,
        });
        return (React.createElement(I18nextProvider, { i18n: i18n },
            React.createElement(Comp, __assign({}, props))));
    };
}
//# sourceMappingURL=withI18nextProvider.js.map